const React = require('react')
const initI18n = require('./src/utils/i18n')
const { I18nextProvider } = require('react-i18next')

exports.wrapPageElement = ({ element, props }) => {
  const i18n = initI18n({
    lang: props.pageContext.lang,
    langs: props.pageContext.langs,
    defaultLang: props.pageContext.defaultLang,
    translations: props.pageContext.translations,
  })

  return <I18nextProvider i18n={i18n}>{element}</I18nextProvider>
}
